import React, { useState } from "react";
import { TableCell, TableRow, IconButton } from "@mui/material";
import styles from "./TirthListing.module.scss";
import { Edit, Delete } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CustomDialog from "../../../../library/common/CustomDialog";
import { api } from "../../../../services";
import { CONSTANTS } from "../../../../library/common/constant";
import { throttle } from "lodash";

const { DELETE_CONFIRM_TITLE, DELETE_CONFIRM_MESSAGE, THROTTLE_DURATION } =
  CONSTANTS;

const TirthItem = ({ index, tirthItem, getTirthList }) => {
  const navigate = useNavigate();
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenDeleteDialogue = () => {
    setDialogOpen(true);
  };

  const handleCloseDeleteDialogue = () => {
    setDialogOpen(false);
  };

  const { _id, coverImage, slug, address, district, state, title } =
    tirthItem || {};

  const deleteTirth = throttle(async () => {
    try {
      setIsLoading(true);
      await api.delete(`/tirths/${tirthItem?._id}`);
      await getTirthList();
      handleCloseDeleteDialogue();
    } catch (error) {
      console.error("Failed to delete: ", error);
    } finally {
      setIsLoading(false);
    }
  }, THROTTLE_DURATION);

  return (
    <>
      {tirthItem && (
        <TableRow key={_id}>
          <TableCell height="100px" width="150px">
            <img
              src={coverImage}
              alt={slug}
              style={{ height: "100%", width: "100%" }}
            />
          </TableCell>
          <TableCell>{title?.en}</TableCell>
          <TableCell>
            {district != null
              ? district?.name?.en + " - " + state?.name?.en
              : ""}
          </TableCell>

          <TableCell>{address?.en}</TableCell>

          <TableCell className={styles.icon_button_container}>
            <div className={styles.pageButtons}>
              <IconButton
                className={styles.edit_icon}
                onClick={() => navigate(`/tirth/edit/${slug}`)}
              >
                <Edit />
              </IconButton>
              <IconButton
                className={styles.delete_icon}
                onClick={handleOpenDeleteDialogue}
              >
                <Delete />
              </IconButton>
            </div>
          </TableCell>
        </TableRow>
      )}
      <CustomDialog
        open={isDialogOpen}
        title={DELETE_CONFIRM_TITLE}
        content={DELETE_CONFIRM_MESSAGE}
        onClose={handleCloseDeleteDialogue}
        onSecondaryClick={handleCloseDeleteDialogue}
        onPrimaryClick={deleteTirth}
        disablePrimary={isLoading}
      />
    </>
  );
};

export default TirthItem;
